module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-55Rg.b32bcf5.woff";